import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const AddBook = ({setLoading}) => {
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        subject: '',
        book_no: '',
        isbn_no: '',
        publisher: '',
        author: '',
        rack_no: '',
        quantity: '',
        price: '',
        description: '',
    });
      const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [category, setCategory] = useState([]);
    const [subjects, setSubjects] = useState([]);



               const fetchCategory = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-category');
        
                        if (response.ok) {
                            const data = await response.json();
const categoryList = data.map(item => item.category);
                            setCategory(categoryList);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


               const fetchSubjects = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-subject');
        
                        if (response.ok) {
                            const data = await response.json();
const subList = data.map(item => item.subject);
                            setSubjects(subList);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


         useEffect(() => {
      fetchCategory();
      fetchSubjects();
    }, []);
    
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddNewCategory = () => {
        const newCategory = prompt('Enter new category:');
        if (newCategory && !category.includes(newCategory)) {
            setCategory((prev) => [...prev, newCategory]);
            setFormData((prev) => ({
                ...prev,
                category: newCategory
            }));
        }
    };

    const handleAddNewSubject = () => {
        const newSubject = prompt('Enter new subject:');
        if (newSubject && !subjects.includes(newSubject)) {
            setSubjects((prev) => [...prev, newSubject]);
            setFormData((prev) => ({
                ...prev,
                subject: newSubject
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch('https://api.kcian.in/libadd-book', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

        setLoading(false);
            if (response.ok) {
                      setResponse2({ message: 'Book Added Successfully!', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);

                setFormData({
                    title: '',
                    category: '',
                    subject: '',
                    book_no: '',
                    isbn_no: '',
                    publisher: '',
                    author: '',
                    rack_no: '',
                    quantity: '',
                    price: '',
                    description: '',
                });
            } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
            }
        } catch (error) {
        setLoading(false);
            console.error('Error:', error);
        }
    };

    return (
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1='Library' message2='Add Book' />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                <div className='profile-card'>
                    <p className='profile-heading'>Add Book</p>

                    <form onSubmit={handleSubmit}>
                        <div className='row'>

                            {/* Book Title */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Book Title*</label>
                                    <input type='text' name='title' value={formData.title} onChange={handleChange} className='profile-input' required />
                                </div>
                            </div>

                            {/* Book category */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Book Category*</label>
                                    <select name='category' value={formData.category} onChange={(e) => {
                                        if (e.target.value === 'add_new') {
                                            handleAddNewCategory();
                                        } else {
                                            handleChange(e);
                                        }
                                    }} className='profile-input' required>
                                        <option value=''>--- Select ---</option>
                                        {category.map((cat, index) => (
                                            <option key={index} value={cat}>{cat}</option>
                                        ))}
                                        <option value='add_new'>+ Add New Category</option>
                                    </select>
                                </div>
                            </div>

                            {/* Subject */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Subject*</label>
                                    <select name='subject' value={formData.subject} onChange={(e) => {
                                        if (e.target.value === 'add_new') {
                                            handleAddNewSubject();
                                        } else {
                                            handleChange(e);
                                        }
                                    }} className='profile-input' required>
                                        <option value=''>--- Select ---</option>
                                        {subjects.map((sub, index) => (
                                            <option key={index} value={sub}>{sub}</option>
                                        ))}
                                        <option value='add_new'>+ Add New Subject</option>
                                    </select>
                                </div>
                            </div>

                            {/* Book No */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Book No*</label>
                                    <input type='number' name='book_no' value={formData.book_no} onChange={handleChange} className='profile-input' required />
                                </div>
                            </div>

                            {/* ISBN No */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>ISBN No*</label>
                                    <input type='text' name='isbn_no' value={formData.isbn_no} onChange={handleChange} className='profile-input' />
                                </div>
                            </div>

                            {/* Publisher Name */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Publisher Name*</label>
                                    <input type='text' name='publisher' value={formData.publisher} onChange={handleChange} className='profile-input' />
                                </div>
                            </div>

                            {/* Author Name */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Author Name*</label>
                                    <input type='text' name='author' value={formData.author} onChange={handleChange} className='profile-input' />
                                </div>
                            </div>

                            {/* Rack No */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Rack Number*</label>
                                    <input type='number' name='rack_no' value={formData.rack_no} onChange={handleChange} className='profile-input' required />
                                </div>
                            </div>

                            {/* Quantity */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Quantity*</label>
                                    <input type='number' name='quantity' value={formData.quantity} onChange={handleChange} className='profile-input' required />
                                </div>
                            </div>

                            {/* Price */}
                            <div className='mb-4 col-md-4'>
                                <div className='profile-input-area'>
                                    <label className='profile-badge'>Book Price*</label>
                                    <input type='number' name='price' value={formData.price} onChange={handleChange} className='profile-input' required />
                                </div>
                            </div>

                        </div>

                        {/* Description */}
                        <div className='mb-4 mt-2 col-md-12 col-12'>
                            <div className='profile-input-area'>
                                <label className='profile-badge'>Description*</label>
                                <textarea name='description' value={formData.description} onChange={handleChange} className='profile-input' rows='3' />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className='col-12 text-center'>
                            <button type='submit' className='profile-btn'><FaCheck /> Submit</button>
                        </div>

                    </form>
                </div>
            </div>
        </section>
    );
};

export default AddBook;
